import { render } from "./ScheduleCalendar.vue?vue&type=template&id=43502144"
import script from "./ScheduleCalendar.vue?vue&type=script&lang=ts"
export * from "./ScheduleCalendar.vue?vue&type=script&lang=ts"
script.render = render

export default script